import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import './header.scss'
import logo from "../../../images/logo.png"
import { PersonAddAlt } from '@mui/icons-material';
import { NavHashLink as Link } from 'react-router-hash-link';
import { NavLink } from 'react-router-dom';

const Header = () => {
    return (
        <>
            <Navbar collapseOnSelect expand="md" className="header-area" sticky="top">
                <Container>
                    <Navbar.Brand as={Link} to="/#heroArea"><img className="logo" src={logo} alt="Image not found " /></Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav  " >
                        <Nav className="me-auto header-left ">
                            <Nav.Link as={Link} to="/#heroArea" className={isActive =>
                                "nav-link" + (!isActive ? " unselected" : "")
                            } >HOME</Nav.Link>
                            <Nav.Link as={Link} to="/#course"
                            >COURSE</Nav.Link>
                            <Nav.Link as={Link} to="/#about"
                            >ABOUT</Nav.Link>
                            <Nav.Link as={Link} to="/#gallary"
                            >GALLERY</Nav.Link>
                            <Nav.Link as={Link} to="/#contact"
                            >CONTACT</Nav.Link>

                        </Nav>
                        <Nav className="header-right">
                            <Nav.Link as={NavLink} to="/reg" className="register"> <span>Registration</span>  <PersonAddAlt /></Nav.Link>

                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
};

export default Header;